import React from 'react';
import { observer } from 'mobx-react';
import { Button, Flex, Popover, Switch, Text } from 'core/components';
import { SESSION_FEATURES } from '@kentik/ui-shared/kaizen/constants';
import { FiSliders } from 'react-icons/fi';

const SessionFeatureSelector = observer(({ selectedFeatures, onToggleFeature }) => {
  if (SESSION_FEATURES.length === 0) {
    return null;
  }

  const activeCount = selectedFeatures.length;

  return (
    <Popover
      position="bottom-right"
      content={
        <Flex flexDirection="column" p={2} gap={2} width={340}>
          <Text fontWeight="bold">Session Features</Text>
          {SESSION_FEATURES.map((feature) => {
            const isSelected = selectedFeatures.includes(feature.key);
            return (
              <Flex key={feature.key} alignItems="flex-start" gap={2}>
                <Switch ariaLabel={feature.label} checked={isSelected} onChange={() => onToggleFeature(feature.key)} />
                <Flex flexDirection="column" gap="2px">
                  <Text>{feature.label}</Text>
                  <Text small muted>
                    {feature.description}
                  </Text>
                </Flex>
              </Flex>
            );
          })}
        </Flex>
      }
    >
      <Button minimal icon={FiSliders} title="Configure session features">
        <Text>Features{activeCount > 0 ? ` (${activeCount})` : ''}</Text>
      </Button>
    </Popover>
  );
});

export default SessionFeatureSelector;
